import { envConfig } from "config";

const QuestionIds = {
  Age: envConfig.ageQuestionId,
};

export default QuestionIds;
